import { SafeBaseObject } from "@app/core/models/base-object.models"
import { DynamicApiResponse, DynamicApiResponsePaginatedModel } from "@app/core/models/dynamic-api-response.model"
import { DateTime } from "luxon"
import { ResGroups } from "./res-service.models"
import { BookingGuest, BookingJourneySupplement, BookingSupplement, PriceSetupIDEnum, ResBooking } from "./res-booking.model"

export interface ResBkgItemPaxGroupList {
  paxGroupID:number
  itemsIDs:number[]
}
export class ResBkgItem extends SafeBaseObject{
  itemKey=''
  itemKeyOrder=''
  itemsID:number[] = []
  roomConfHdrID:number[] = []
  isVirtual = false

  bkgID = 0

  itineraryDate = DateTime.invalid('empty')
  travelEndDate = DateTime.invalid('empty')

  guestCod = ''
  guestName = ''
  guests:BookingGuest[]=[]
  roomID = 0
  otherGroupGuests:BookingGuest[]=[]

  packageID = 0
  productCod = ''
  productName = ''
  itemName = ''

  experienceID = 0
  experienceTemplateHdrID = 0

  tierID = 0

  suiteCategoryID = 0
  suiteCategory = ''
  priceCategoryID = 0
  priceCategory = ''
  suiteNo = 0

  quantity = 0

  sellingPrice = 0
  sellingPriceTax = 0
  sellingPriceCurrency = ''

  cost = 0
  costTax = 0
  costCurrency = ''
  costBkgCurrency = 0
  costRoe = 0

  bkgCurrency = ''

  paxGroupID = 0
  payerGroupName = ''

  status = ''

  canEdit = false
  villaCost = false
  canDelete = false
  marginType = ''
  marginAmount = 0
  marginPercentage = 0

  prePost = ''

  aggregationGroupRow = 0
  aggregationCodes = ''
  aggregationDescription = ''
  aggregationField = ''
  aggregations:ResGroups[] = []
  aggregationsCostTotals:{currency:string,amount:number}[] = []
  aggregationsCostTaxTotals:{currency:string,amount:number}[] = []
  aggregationsCostGrossTotals:{currency:string,amount:number}[] = []


  isProduct = false
  productID = 0
  editAllocation = false
  editCostAndPrice = false

  isValid = false
  nightNum = 0
  wl = false
  onRequest = false

  bedType = ''
  mcSellingPrice = 0
  mcSellingTax = 0
  mcSellingCurrency = ''
  mcSellingROE = 0

  actualCost = 0
  actualTax = 0
  actualCurrency = ''
  actualExchangeRate = 0

  priceSetupID = 0
  priceSetUpName = ''
  originalPriceSetupID = 0

  commissionable = false
  forcedNetComm = false
  commissionBaseAmount = 0
  commissionPercentage = 0
  vatCommissionPercentage = 0
  commissionNet = 0
  commissionVat = 0
  commissionTotal = 0
  canModifyWholeUnit = false
  splitForItemID = false
  isTailorMade = false
  tailorMadeHdr = false
  allPaxGroup:ResBkgItemPaxGroupList[]=[]
  supplements:BookingSupplement[]=[]
  touched = false
  hasRemarkAir = false
  hasRemark = false
  remarkHasChange = false
  remarkAir = ''
  remark = ''
  originalRemark = ''
  hasSupplierRemark = false
  supplierRemarkHasChange = false
  supplierRemark = ''
  originalSupplierRemark = ''
  hasAttachment = false
  fileGuid = ''
  fileId = 0
  fileName = ''
  hasSupplierAttachment = false
  fileGuidSupRmk = ''
  fileIdSupRmk = 0
  fileNameSupRmk = ''
  hasDetails = false
  supplierID = 0
  serviceID = 0
  optionID = 0
  disableInvoice = false
  amountInvoice = 0
  taxAmountInvoice = 0
  isFinal = false
  realMargin = 0
  purchaseOrderID = 0
  operationalNote = ''
  originalOperationalNote = ''
  currencyCodInvoice = ''
  amountInvoiceBkgCurrency = 0
  isTransport = false
  hasDateTime = false
  isSupplierDisabled = false
  exchangeRate = 0
  amountInvoiceImported = 0
  taxAmountInvoiceImported = 0
  amountInvBkgCurrencyImported = 0

  marginActual = 0
  marginOverlay = 0
  sellingPriceOverlay = 0
  sellingPriceActual = 0
  orderField = 0

  optionIDFh = 0
  itemNameFh = ''
  country = ''
  countryID = 0
  payerID = 0
  hideOnOverlay = false
  isVirtualOpened = false
  grossCost = 0
  includeVat = true
  vat = 0

  priceTypeID = 0
  priceTypeName = ''
  constructor(data?:any) {
    super();
    if (data) {
      super.updateData(data)
      this.updateData(data)
    }
  }
  static breakRulesBase(item1:BookingSupplement,item2:BookingSupplement|BookingJourneySupplement) {
    return (item1.serviceTypeID === item2.serviceTypeID
              || (item2.optionID === 0
                  && item2.serviceID === 0
                  && item2.experienceID === 0
                )
            )
            && (!item1.splitForItemID || item1.itemID===item2.itemID || item2.internalType==='BookingJourneySupplement')
            && item1.serviceID      === item2.serviceID
            && item1.optionID       === item2.optionID
            && item1.tierID         === item2.tierID
            && item1.experienceID   === item2.experienceID
            && item1.bedType        === item2.bedType
            && item1.itineraryDate.hasSame(item2.itineraryDate,'day')
  }
  static breakRules(item1:BookingSupplement,item2:BookingSupplement|BookingJourneySupplement,guestCod?:string) {
    return ResBkgItem.breakRulesBase(item1,item2)
            && (item1.paxGroupID === item2.paxGroupID || item1.itemGroupID === item2.itemGroupID)
            && (!guestCod
              || !item1.canModifyWholeUnit
              || item1.guestCod === guestCod
            )
  }
  static createFromSupplement(item:BookingSupplement,booking:ResBooking,fromGuest=false) {
    const bkgItem = new ResBkgItem()
      bkgItem.serviceID      = item.serviceID
      bkgItem.optionID       = item.optionID
      bkgItem.experienceID   = item.experienceID
      bkgItem.tierID         = item.tierID

      bkgItem.itemKey = item.itemID.toString()
      bkgItem.itemKeyOrder = `${bkgItem.orderField}_${item.itemID}`
      bkgItem.itemsID.push(item.itemID)
      bkgItem.itemName = item.optionName
      bkgItem.quantity = item.quantityPP
      bkgItem.bkgID=item.bkgID
      bkgItem.itineraryDate = item.itineraryDate
      bkgItem.travelEndDate = item.tailorMadeItineraryDateTo
      bkgItem.guestCod = item.guestCod
      bkgItem.priceSetupID = item.priceSetupID
      bkgItem.priceSetUpName = item.priceSetUpName
      bkgItem.originalPriceSetupID = item.originalPriceSetupID

      bkgItem.sellingPrice = item.sellingPrice
      bkgItem.sellingPriceTax = item.sellingPriceTax
      bkgItem.sellingPriceCurrency = booking?.bkgCurrency ?? item.sellingPriceCurrency ?? ''
      bkgItem.includeVat = item.includeVat
      bkgItem.vat = item.vat

      bkgItem.marginType = item.marginType !== '' ? item.marginType : 'NET'
      bkgItem.marginAmount = item.marginAmount
      bkgItem.marginPercentage = item.marginPercentage

      bkgItem.mcSellingCurrency=(item.mcSellingCurrency ?? '') !== '' ? item.mcSellingCurrency: booking?.bkgCurrency ?? bkgItem.sellingPriceCurrency
      bkgItem.mcSellingPrice=item.mcSellingPrice
      bkgItem.mcSellingTax=item.mcSellingTax
      bkgItem.mcSellingROE=item.mcSellingROE

      bkgItem.actualCost = item.actualCost
      bkgItem.actualTax = item.actualTax
      bkgItem.actualCurrency = item.actualCurrency
      bkgItem.actualExchangeRate = item.actualExchangeRate

      bkgItem.cost = item.cost
      bkgItem.costTax =item.costTax
      bkgItem.costCurrency = item.costCurrency
      bkgItem.costRoe = item.exchangeRate

      bkgItem.wl = item.wl
      bkgItem.onRequest = item.onRequest
      bkgItem.isTailorMade = item.isTailorMade
      bkgItem.tailorMadeHdr = item.tailorMadeHdr
      bkgItem.paxGroupID = item.paxGroupID
      bkgItem.payerID = item.payerID

      bkgItem.canModifyWholeUnit = item.canModifyWholeUnit
      bkgItem.splitForItemID = item.splitForItemID

      bkgItem.priceTypeID = item.priceTypeID
      bkgItem.priceTypeName = item.priceTypeName

      bkgItem.commissionable = item.commissionable ?? false
      bkgItem.forcedNetComm = item.forcedNetComm
      bkgItem.commissionBaseAmount = item.commissionBaseAmount
      bkgItem.commissionPercentage = item.commissionPercentage
      bkgItem.vatCommissionPercentage = item.vatCommissionPercentage
      bkgItem.commissionNet = item.commission
      bkgItem.commissionVat = item.commissionVat
      bkgItem.commissionTotal=bkgItem.commissionNet+bkgItem.commissionVat


      bkgItem.bkgCurrency = booking?.bkgCurrency ?? bkgItem.sellingPriceCurrency ?? ''

      bkgItem.canEdit = item.canEdit
      bkgItem.canDelete = item.canDelete

      bkgItem.status = bkgItem.wl ? 'W' : (item.onRequest ? 'A' : 'R')
      //bkgItem.nightNum = item.nightNum

      bkgItem.isValid = true

      bkgItem.bedType = item.bedType

      if(item.serviceID===0 && item.optionID===0) {

      } else {}


      bkgItem.hasRemarkAir = item.remarkAir.length > 0
      bkgItem.remarkAir = item.remarkAir

      bkgItem.hasRemark = item.itemID > 0
      bkgItem.remark = item.message
      bkgItem.originalRemark = bkgItem.remark

      bkgItem.hasAttachment = item.fileGuid.length>0
      bkgItem.fileGuid = item.fileGuid
      bkgItem.fileId = item.fileId
      bkgItem.fileName = item.fileName

      bkgItem.hasSupplierRemark = item.itemID > 0
      bkgItem.supplierRemark = item.supplierRemark
      bkgItem.originalSupplierRemark = bkgItem.supplierRemark

      bkgItem.hasSupplierAttachment = item.fileGuidSupRmk.length > 0
      bkgItem.fileGuidSupRmk = item.fileGuidSupRmk
      bkgItem.fileIdSupRmk = item.fileIdSupRmk
      bkgItem.fileNameSupRmk = item.fileNameSupRmk

      bkgItem.hasDetails = bkgItem.hasRemarkAir || bkgItem.hasRemark || bkgItem.hasAttachment || bkgItem.hasSupplierAttachment

      if(booking.isValid()) {
        bkgItem.allPaxGroup = []
        booking.supplements.filter(s=>ResBkgItem.breakRulesBase(s,item))
          .forEach(s=>{
            if(bkgItem.allPaxGroup.find(pg=>pg.paxGroupID===s.paxGroupID)) return
            const itemIDs = booking.supplements.filter(item=>ResBkgItem.breakRules(item,s)).map(item=>item.itemID)
            bkgItem.allPaxGroup.push({paxGroupID:s.paxGroupID,itemsIDs:itemIDs})
          })

        bkgItem.allPaxGroup = bkgItem.allPaxGroup.sort((a,b)=>a.paxGroupID-b.paxGroupID)

        const guests = booking.getAllClonedGuests()
        booking.supplements.filter(s=>ResBkgItem.breakRules(s,item,fromGuest ? item.guestCod : undefined))
          .forEach(s=>{
            if(!bkgItem.itemsID.includes(s.itemID)) {
              bkgItem.itemsID.push(s.itemID)
            }
            bkgItem.supplements.push(s.clone())
            const g = guests.find(g=>g.guestCod===s.guestCod)
            if(g) bkgItem.addGuest(g)
          })
        guests.forEach(g=>{
          const exist = bkgItem.guests.find(item=>item.guestCod===g.guestCod)
          if(!exist) bkgItem.otherGroupGuests.push(g)
        })
      }

      return bkgItem
  }
  static createFromJourneySupplement(item:BookingJourneySupplement,booking:ResBooking) {
    const bkgItem = new ResBkgItem()


    //bkgItem.serviceTypeID = item.serviceTypeID ???
    //bkgItem.itemGroupID    = item.itemGroupID ???
    bkgItem.serviceID      = item.serviceID
    bkgItem.optionID       = item.optionID
    bkgItem.experienceID   = item.experienceID
    bkgItem.tierID         = item.tierID

    bkgItem.itemKey = item.itemID.toString()
    bkgItem.itemsID.push(item.itemID)
    bkgItem.itemName = item.optionName
    bkgItem.quantity = item.quantity
    bkgItem.bkgID = booking.bkgID
    bkgItem.itineraryDate = item.itineraryDate
    bkgItem.travelEndDate = item.tailorMadeItineraryDateTo
    bkgItem.priceSetupID = item.priceSetupID
    bkgItem.originalPriceSetupID = item.originalPriceSetupID

    bkgItem.sellingPrice = item.sellingPrice
    bkgItem.sellingPriceTax = item.sellingPriceTax
    bkgItem.sellingPriceCurrency = booking.bkgCurrency ?? item.sellingPriceCurrency
    bkgItem.includeVat = item.includeVat
    bkgItem.vat = item.vat

    bkgItem.marginType = item.marginType !== '' ? item.marginType : 'NET'
    bkgItem.marginAmount = item.marginAmount
    bkgItem.marginPercentage = item.marginPercentage

    bkgItem.mcSellingCurrency=item.mcSellingCurrency
    bkgItem.mcSellingPrice=item.mcSellingPrice
    bkgItem.mcSellingTax=item.mcSellingTax
    bkgItem.mcSellingROE=item.mcSellingROE

    bkgItem.cost = item.cost
    bkgItem.costTax =item.costTax
    bkgItem.costCurrency = item.costCurrency
    bkgItem.costRoe = item.exchangeRate
    bkgItem.bkgCurrency = booking.bkgCurrency
    bkgItem.wl = item.wl
    bkgItem.onRequest = item.onRequest

    bkgItem.canEdit = item.canEdit
    bkgItem.canDelete = item.canDelete
    bkgItem.isTailorMade = item.isTailorMade
    bkgItem.tailorMadeHdr = item.tailorMadeHdr
    bkgItem.paxGroupID = item.paxGroupID
    bkgItem.payerID = item.payerID

    bkgItem.canModifyWholeUnit = item.canModifyWholeUnit
    bkgItem.splitForItemID = item.splitForItemID

    bkgItem.priceTypeID = item.priceTypeID
    bkgItem.priceTypeName = item.priceTypeName

    bkgItem.commissionable = item.commissionable
    bkgItem.forcedNetComm = item.forcedNetComm
    bkgItem.commissionBaseAmount = item.commissionBaseAmount
    bkgItem.commissionPercentage = item.commissionPercentage
    bkgItem.vatCommissionPercentage = item.vatCommissionPercentage
    bkgItem.commissionNet = item.commission
    bkgItem.commissionVat = item.commissionVat
    bkgItem.commissionTotal = bkgItem.commissionNet+bkgItem.commissionVat


    bkgItem.status = bkgItem.wl ? 'W' : (item.onRequest ? 'A' : 'R')
    bkgItem.nightNum = item.nightNum

    bkgItem.isValid = true

    bkgItem.bedType = item.bedType
    bkgItem.touched = item.touched

    bkgItem.villaCost = false //!item.canEdit && item.canEditVillaCost
    if(bkgItem.villaCost) {
      bkgItem.isProduct = true
      bkgItem.editAllocation = false
      bkgItem.editCostAndPrice = true
      bkgItem.productID = item.productID
    }

    if(item.serviceID===0 && item.optionID===0) {
    } else {

    }

    if(booking.isValid()) {
      bkgItem.allPaxGroup = []
      booking.supplements.filter(s=>ResBkgItem.breakRulesBase(s,item))
        .forEach(s=>{
          if(bkgItem.allPaxGroup.find(pg=>pg.paxGroupID===s.paxGroupID)) return
          const itemIDs = booking.supplements.filter(item=>ResBkgItem.breakRules(item,s)).map(item=>item.itemID)
          bkgItem.allPaxGroup.push({paxGroupID:s.paxGroupID,itemsIDs:itemIDs})
        })

      bkgItem.allPaxGroup = bkgItem.allPaxGroup.sort((a,b)=>a.paxGroupID-b.paxGroupID)

      const guests = booking.getAllClonedGuests()
      const payers:number[] = []
      booking.supplements.filter(s=>ResBkgItem.breakRules(s,item))
        .forEach(s=>{
          if(!bkgItem.itemsID.includes(s.itemID)) {
            bkgItem.itemsID.push(s.itemID)
          }
          if(s.payerID>0) payers.push(s.payerID)
          bkgItem.supplements.push(s.clone())
          const g = guests.find(g=>g.guestCod===s.guestCod)
          if(g) bkgItem.addGuest(g)
        })
      if(item.isTailorMade && bkgItem.supplements.length===0) {
          bkgItem.guests = guests
          const journeyClone = item.clone()
          bkgItem.guests.forEach(g=>{
            g.isSelected=true
            const exist = bkgItem.supplements.find(s => s.guestCod === g.guestCod)
            if (exist) return
            const created = BookingSupplement.createFromBookingJourney(journeyClone, g)
            if (created) bkgItem.supplements.push(created)
          })
      }
      guests.forEach(g=>{
        const exist = bkgItem.guests.find(item=>item.guestCod===g.guestCod)
        if(!exist) bkgItem.otherGroupGuests.push(g)
      })

      const firstPayer = payers[0] ?? 0
      if(payers.every(p=>p===firstPayer)) {
        bkgItem.payerID = firstPayer
      }

      if (!bkgItem.priceSetUpName) {
        bkgItem.priceSetUpName = bkgItem.supplements[0]?.priceSetUpName ?? ''
      }

    }


    if(item.isTailorMade) {
      if(bkgItem.supplements.length>0 && !item.touched){
        const supplement = bkgItem.supplements[0]
        switch(bkgItem.priceSetupID) {
          case PriceSetupIDEnum.PER_PAX_PRICE_SETUP_ID:
            bkgItem.sellingPrice = supplement.sellingPrice / bkgItem.quantity
            bkgItem.sellingPriceTax = supplement.sellingPriceTax / bkgItem.quantity
            bkgItem.mcSellingPrice = supplement.mcSellingPrice / bkgItem.quantity
            bkgItem.mcSellingTax = supplement.mcSellingTax / bkgItem.quantity
            bkgItem.cost = supplement.cost / bkgItem.quantity
            bkgItem.costTax = supplement.costTax / bkgItem.quantity
            bkgItem.commissionBaseAmount = supplement.commissionBaseAmount / bkgItem.quantity
            bkgItem.commissionNet = supplement.commission / bkgItem.quantity
            bkgItem.commissionVat = supplement.commissionVat / bkgItem.quantity
            break;
          case PriceSetupIDEnum.PER_UNIT_PRICE_SETUP_ID:
            bkgItem.sellingPrice /= bkgItem.quantity
            bkgItem.sellingPriceTax /= bkgItem.quantity
            bkgItem.mcSellingPrice /= bkgItem.quantity
            bkgItem.mcSellingTax /= bkgItem.quantity
            bkgItem.cost /= bkgItem.quantity
            bkgItem.costTax /= bkgItem.quantity
            bkgItem.commissionBaseAmount /= bkgItem.quantity
            bkgItem.commissionNet /= bkgItem.quantity
            bkgItem.commissionVat /= bkgItem.quantity
            break;
        }
        bkgItem.commissionTotal = bkgItem.commissionNet + bkgItem.commissionVat
      }

    }
    return bkgItem
  }
  guestSelectedIfTm(guestCod:string) {
    if(!this.isTailorMade) return false
    const guest = this.supplements.find(s=>s.guestCod===guestCod)
    if(!guest) return false
    return true
  }
  updateItem(item:BookingJourneySupplement | BookingSupplement) {

    item.priceSetupID = this.priceSetupID

    item.sellingPrice = this.sellingPrice
    item.sellingPriceTax = this.sellingPriceTax

    item.marginType = this.marginType
    item.marginAmount = this.marginAmount
    item.marginPercentage = this.marginPercentage

    item.mcSellingCurrency=this.mcSellingCurrency
    item.mcSellingPrice=this.mcSellingPrice
    item.mcSellingTax=this.mcSellingTax
    item.mcSellingROE=this.mcSellingROE

    item.cost = this.cost
    item.costTax = this.costTax
    item.costCurrency = this.costCurrency
    item.exchangeRate = this.costRoe

    item.commissionable = this.commissionable
    item.forcedNetComm = this.forcedNetComm
    item.commissionBaseAmount = this.commissionBaseAmount
    item.commissionPercentage = this.commissionPercentage
    item.vatCommissionPercentage = this.vatCommissionPercentage
    item.commission = this.commissionNet
    item.commissionVat = this.commissionVat

    item.bedType = this.bedType
    item.qty = this.quantity
    item.touched = true
  }
  updateData(data: any) {
    this.itemKey = `${data.ItemID}`

    this.itemsID = `${data.ItemID}`.split(',').map(itemId=>+itemId)

    this.roomConfHdrID = `${data.RoomConfHdrID}`.split(',').map(roomConfHdrID=>+roomConfHdrID)

    this.isProduct = this.productCod === 'CRU'

    this.isValid = this.itemsID.length > 0

    if(this.mcSellingCurrency==='') {
      this.mcSellingCurrency = this.bkgCurrency
      this.mcSellingROE = 1
    }
    if(this.costCurrency==='') {
      this.costCurrency = this.bkgCurrency
      this.costRoe = 1
    }
    if(!this.onRequest && this.status==='On Request') this.onRequest = true
    if(!this.wl && this.status==='Wait List') this.wl = true
    if(this.productCod==='EXT') {
      this.hideOnOverlay = true
    }

  }

  addGuest(guest?:BookingGuest) {
    if(!guest) return
    if(this.guests.find(g=>g.guestCod===guest.guestCod)) return
    this.guests.push(guest)
  }

  static createEmptyPage() {

    const emptyApiResponse = new DynamicApiResponse({
      pageNumber: 1,
      pageTotal: 0,
      recordsCount: 0,
      body: []
    })

    return new DynamicApiResponsePaginatedModel<ResBkgItem>(emptyApiResponse)
  }
}

export class ResBkgItemTotal extends SafeBaseObject {
  sellingPrice = 0
  sellingPriceCurrency = ''
  cost = 0
  costCurrency = ''
  costBkgCurrency = 0
  bkgCurrency = ''
  src = ''
  margin = 0
  realMargin = 0

  amountInvoice = 0
  amountInvoiceImported = 0

  constructor(data?:any) {
    super();
    this.updateData(data)
  }

  override updateData(data: any) {
    if (!data) return;

    super.updateData(data)
  }
}
export class ResBkgItemOverlay extends SafeBaseObject {
  id = 0
  recordType = ''
  numDays = 0
  numNights = 0
  numGuest = 0
  sellingPrice = 0
  sellingPricePerPax = 0
  perDiem = 0
  perDiemPerPax = 0
  perNight = 0
  perNightPerPax = 0
  sellingPriceActual = 0
  sellingPriceActualPerPax = 0
  perDiemActual = 0
  perDiemActualPerPax = 0
  perNightActual = 0
  perNightActualPerPax = 0

  constructor(data?:any) {
    super();
    this.updateData(data)
  }

  override updateData(data: any) {
    if (!data) return;

    super.updateData(data)
  }
}

export class ResBkgItemOverlayPerPax extends SafeBaseObject {
  ID = 0
  recordType = ''
  guestCod = ''
  numDays = 0
  numNights = 0
  sellingPrice = 0
  perDiem = 0
  perNight = 0
  sellingPriceActual = 0
  perDiemActual = 0
  perNightActual = 0

  constructor(data?:any) {
    super();
    this.updateData(data)
  }

}

export class ResBkgItemOverlayPerGroup extends SafeBaseObject {
  ID = 0
  recordType = ''
  paxGroupID = 0
  numGuest = 0
  numDays = 0
  numNights = 0
  sellingPrice = 0
  perDiem = 0
  perNight = 0
  sellingPriceActual = 0
  perDiemActual = 0
  perNightActual = 0

  constructor(data?: any) {
    super();
    this.updateData(data)
  }

}
export class ResBkgItemFlightInfo extends SafeBaseObject{
  bkgID	= 0
  itemID = 0
  pnr = ''
  airLineID = 0
  airLineCod = ''
  airLine = ''
  airClassID = 0
  airClass = ''
  airClassName = ''
  departureDate = DateTime.invalid('empty')
  departureAirportID = 0
  departureAirportName = ''
  arrivalDate = DateTime.invalid('empty')
  arrivalAirportID = 0
  arrivalAirportName = ''

  constructor(data?:any) {
    super();
    this.updateData(data)
  }

  override updateData(data: any) {
    if (!data) return;

    super.updateData(data)
  }
}
export class ResBkgGroupedItems {
  itemsPaginated = ResBkgItem.createEmptyPage()
  groups:ResGroups[] = []
  total = new ResBkgItemTotal()
  allTotals:ResBkgItemTotal[] = []
  overlay: ResBkgItemOverlay[] = []
  overlayPerPax: ResBkgItemOverlayPerPax[] = []
  overlayPerGroup: ResBkgItemOverlayPerGroup[] = []
  overlayMarginCountries: ResBkgItemOverlayMarginCountry[] = []
  overlayNote: string = ''
  items:ResBkgItem[]  =[]

  get isValid() {
    return this.groups.length>0
  }
  normalizeGuests(booking:ResBooking) {
    const guests = booking.getAllGuests()
    this.itemsPaginated.content.forEach(item=>{
      item.guestCod.split(',').forEach(code=>{
        item.addGuest(guests.find(g=>g.guestCod===code))
      })
      item.guestName =  item.guests.map(g=>g.displayName()).join(', ')
    })
  }
}

export interface IResBkgItemApiParams {
  PageNum?: number
  PageSize?:number
  ProductTypeID?: number
  ProductName?: string
  GuestCod?: number[]
  ItemID?: number
  GroupBy?: string
  IsMarginOverlayTab?: string
  ItemListMarginOverlay?:IResBkgItemListMarginOverlay[]
  MarginOverlay?:IResBkgItemListMarginOverlay[]
  OverlayReason?: string
  OldMargin?: number
  NewMargin?: number
}
export interface IResBkgItemListMarginOverlay {
  ItemID: string | number
  ServiceID: number
  OptionID:number
  Margin?:number
  MarginOverlay?:number
  Cost?:number
  SellingPrice?:number
}
export interface IResApiBkgItemsManage {
  ItemID?: number
  ProductCod?: string
  SuiteCategoryID?: number
  PriceCategoryID?: number
  SuiteNo?: number
  Quantity?: number
  SellingPrice?: number
  SellingPriceTax?: number
  Cost?: number
  CostTax?: number
  Vat?: number;
  CostCurrency?: string
  PaxGroupID?: number
  ItemGroupID?: number
  ItineraryDate?: DateTime
  Commissionable?: string
  Status?: string
  BedType?: string
  CostExchangeRate?: string
  MCSellingPrice?: number
  MCSellingTax?: number
  MCSellingCurrency?: string
  MCSellingROE?: number
  MarginType?: string
  MarginAmount?: number
  MarginPercentage?: number

  CommissionBaseAmount?: number
  CommissionPercentage?: number
  MultiVoyageID?: number
  Sync?: string
  Insurance?: string
  TierID?: number
  VoucherID?: string
}

export class ResBkgItemOverlayMarginCountry extends SafeBaseObject {
  country = ''
  countryID = 0
  sellingPrice = 0
  sellingPriceCurrency = ''
  cost = 0
  costCurrency = ''
  costBkgCurrency = 0
  bkgCurrency = ''
  margin = 0
  realMargin = 0
  month = ''
  expectedMargin = 0
  perDiem = 0
  expectedPerDiem = 0
  expectedPerDiemCurrency = ''
  recordType = ''

  constructor(data?: any) {
    super();
    this.updateData(data)
  }
}
